export const thisThemeColor = {
    primary: '#82B194',
    white: '#ffffff',
    black: '#000000',
    transparent: 'rgba(0,0,0,0)',
};